import { createFileRoute, Outlet } from '@tanstack/react-router';
import AuthSetupLayout from 'src/features/plugins/outlook/(auth)/(setup)/layout';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup')({
  component: () => (
    <AuthSetupLayout>
      <Outlet />
    </AuthSetupLayout>
  ),
});
